import React from "react";
import facebook from "../../../assets/img/pics/facebook.png";
import twitter from "../../../assets/img/pics/twitter.png";
import instagram from "../../../assets/img/pics/instagram.png";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <div className="text-center py-4 footer">
      {/* <div className="social_icons py-3"> */}
      {/* <div className="px-1  "><img src={facebook} alt="facebook" /></div>
                <div className="px-1"><img src={twitter} alt="twitter" /></div>
                <div className="px-1"><img src={instagram} alt="instagram" /></div> */}
      {/* </div> */}
      <div className="">
        <span
          className="px-3 footer_links"
          onClick={() => navigate("/about-us")}
        >
          About Us
        </span>
        {/* <span className="px-3 footer_links">Features</span>
                <span className="px-3 footer_links">Pricing</span>
                <span className="px-3 footer_links">Gallery</span>
                <span className="px-3 footer_links">Team</span> */}
        <span
          className="px-3 footer_links"
          onClick={() => navigate("/contact")}
        >
          Contact Us
        </span>
      </div>
      <div className="footer_hr my-3 text-white"></div>
      <span className="  text-white ">© 2023 All Rights Reserved</span>
    </div>
  );
};

export default Footer;
